// ============================================================================
// Default JamCam User Factory
// ============================================================================

import { JamCamUserRecord } from './types';
import { resolveFeatures } from './features';

export function createDefaultJamCamUser(params: {
  userId: string;
  email: string;
  cognitoUsername: string;
  identityProvider?: string;
  displayName?: string;
}): JamCamUserRecord {
  const now = new Date().toISOString();
  return {
    userId: params.userId,
    email: params.email,
    emailLower: params.email.toLowerCase(),
    displayName: params.displayName ?? params.email.split('@')[0],
    cognitoUsername: params.cognitoUsername,
    identityProvider: params.identityProvider ?? 'Cognito',

    createdAt: now,
    updatedAt: now,

    plan: 'free',
    subscriptionStatus: 'none',
    billingCycle: null,
    currentPeriodStart: null,
    currentPeriodEnd: null,
    cancelAtPeriodEnd: false,
    canceledAt: null,
    paymentStatus: 'none',
    gracePeriodEndsAt: null,

    trialEligible: false,
    trialUsed: false,
    trialStartedAt: null,
    trialEndsAt: null,
    trialFingerprint: null,

    stripeCustomerId: null,
    stripeSubscriptionId: null,
    stripePriceId: null,
    stripeProductId: null,
    stripeCheckoutSessionId: null,

    entitlementStatus: 'free',
    entitlementVersion: 1,
    features: resolveFeatures('free'),

    schemaVersion: 1,
  };
}
